import classNames from "classnames";
import { t } from "@/i18n-js/instance";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { useBuilderStore } from "../Hooks/useBuilderStore";
import { useOnClickToggleSection } from "../Hooks/useOnClickToggleSection";
import type { ButtonProps } from "./Button";

export interface AddButtonProps extends ButtonProps {
  shouldKeepSidebarOpen?: boolean;
}

export const AddButton = ({
  shouldKeepSidebarOpen = false,
  className,
  ...rest
}: AddButtonProps) => {
  const onClickHandler = useOnClickToggleSection({
    viewName: "addElements",
    shouldKeepSidebarOpen,
  });
  const actionSidebarView = useBuilderStore(state => state.actionSidebarView);
  const isAddElementActive = actionSidebarView === "addElements";

  return (
    <IconButton
      name={
        isAddElementActive
          ? "24-builder-ui-sidebar-add-element-filled"
          : "24-builder-ui-sidebar-add-element"
      }
      iconSize={24}
      tooltipText={t("settings.site.pages.builder.elements")}
      tooltipPosition="right"
      buttonSize={32}
      ariaLabel={t("add")}
      className={classNames(className, {
        "bg-tertiary": isAddElementActive,
      })}
      iconClassName="!text-dark"
      onClick={onClickHandler}
      data-testid="builder-ui-add-elements-button"
      {...rest}
    />
  );
};
